import React, {useState, useEffect} from "react"
import styled from "styled-components"

const nextIcon = "https://hrflow-ai.imgix.net/next.svg"
const prevIcon = "https://hrflow-ai.imgix.net/prev.svg"


const StyledUl = styled.ul`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 1rem;
  list-style: none;
  .page {
    margin: .5rem;
    border: 1px solid #00cfe1;
    border-radius: 5px;
    padding: 1.3rem 1.5rem;
    font-family: Plain, sans-serif;
    line-height: normal;
    font-size: .7rem;
    text-align: center;
    letter-spacing: .065rem;
    text-transform: uppercase;
    color: #30bfd9;
    cursor: pointer;
  }
  .page.active, .page:hover {
    color: #fff;
    background-color: #00cfe1;
  }

  .prev, .next {
    display: flex;
    align-items: center;
    line-height: normal;
    font-size: .7rem;
    letter-spacing: .065rem;
    text-transform: uppercase;
    color: #30bfd9;
    font-weight: 600;
    cursor: pointer;
  }

  .divider {
    border: .05rem solid #bddae3;
    height: 3.4rem;
    margin-right: 1.5rem;
    margin-left: 1.5rem;
  }

  .prev {
    margin-right: .5rem;
  }
  .next {
    margin-left: .5rem;
  }
  .next.disabled, .prev.disabled {
    opacity: .3;
    cursor: not-allowed;
    pointer-events: none;
  }
`

const Pagination = (props) => {
  const changePage = (page) => {
    props.changePage(page);
  }

  
  const {
    currentPage,
    maxPage,
  } = props;

  const prevClassName = currentPage === 1 ? "prev disabled" : "prev"
  const nextClassName = currentPage === maxPage ? "next disabled" : "next"

  return (
    <StyledUl>
      <li onClick={() => currentPage > 1 && changePage(currentPage - 1)} className={prevClassName}>
        <img src={prevIcon} className="mr-1" alt="prev icon" />  prev
      </li>
      <li className="divider"></li>
      { 
        [...Array(maxPage).keys()].map((_, index) => {

          let className = 'page';

          if (currentPage === index + 1) {
            className += ' active';
          }
          return (
            <li
              className={className}
              onClick={() => changePage(index+1)}
              key={index}
            >
              {index + 1}
            </li>
          )
        })
      }
      <li className="divider"></li>
      <li onClick={() => currentPage < maxPage && changePage(currentPage + 1)} className={nextClassName}>
        next <img src={nextIcon} className="ml-1" alt="next icon" />
      </li>
    </StyledUl>
  );
}

export default Pagination